<template>
  <card-dashboard
    :title="
      $t('dashboard.assigned_students', { length: dataAssignStudent.length })
    "
  >
    <div class="px-10 slick-slider-carousel">
      <VueSlickCarousel v-bind="settings">
        <div
          class="px-5"
          v-for="(item, index) in dataAssignStudent"
          :key="item.username + index"
        >
          <card-carousel
            :avatar="item.avatar_url || '/img/avt_placeholder.jpg'"
            class="flex justify-center"
          >
            <div class="w-full">
              <p class="font-bold mb-2.5 truncate">
                {{ $t("common.name") }}: {{ item.full_name }}
              </p>
              <p class="text-sm font-normal mb-2.5 truncate">
                {{ $t("common.student_code") }}: {{ item.student_code }}
              </p>
              <p class="text-sm font-normal mb-2.5">
                {{ $t("common.grade") }}: {{ item.grade }}
              </p>
            </div>
          </card-carousel>
        </div>
      </VueSlickCarousel>
    </div>
  </card-dashboard>
</template>
<script>
import CardDashboard from "../../Components/CardDashboard";
import CardCarousel from "../../Components/CardCarousel";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import { SETTING_CAROUSEL } from "../../Components/settings-carousel-config";

export default {
  name: "assigned-student",
  components: { CardCarousel, CardDashboard, VueSlickCarousel },
  props: ["dataAssignStudent"],
  data() {
    return {
      settings: SETTING_CAROUSEL
    };
  }
};
</script>
